import React from 'react';
import { FormattedDate, FormattedTime } from 'react-intl';
import PropTypes from 'prop-types';

function OrderDetailsHeader({ data, inspectionIcon }) {
  const date = new Date(data.created_at.date);
  
  return (
    <>
      <div className="flex w-full items-center justify-between my-[0.6vw] font-['Open_Sans']">
        <div className="flex-[8] flex items-center">
          <div className="text-[calc(10px+0.4vw)] font-bold text-black">
            <span>{inspectionIcon}</span>
            <span data-cy="order-details-code">{data.code}</span>
            &#160; &#9679; &#160;
            <span data-cy="order-details-client">
              {data.form.clients ? data.form.clients.client : null}
            </span>
          </div>
        </div>
        <div className="flex-[4] text-right">
          <div
            className="text-[calc(8px+0.3vw)] font-normal text-black"
            data-cy="order-details-date"
          >
            <FormattedDate value={date} />
            &#160; &#9679; &#160;
            <FormattedTime value={date} />
          </div>
        </div>
      </div>
      <hr className="block border-t border-[#E9E9E9] p-0" />
    </>
  );
}

OrderDetailsHeader.propTypes = {
  data: PropTypes.object,
  inspectionIcon: PropTypes.element,
};

export default OrderDetailsHeader;
